export default __webpack_public_path__ + "static/imgSeven-bfea7b83ff411b7f737a111d4b1fa7b0.jpg";